import { Directive } from '@angular/core';

@Directive({
  selector: '[suiDialogLeftHeader]',
  standalone: true,
})
export class SuiDialogLeftHeaderSlot {}

@Directive({
  selector: '[suiDialogLeftContent]',
  standalone: true,
})
export class SuiDialogLeftContentSlot {}

@Directive({
  selector: '[suiDialogRightHeader]',
  standalone: true,
})
export class SuiDialogRightHeaderSlot {}

@Directive({
  selector: '[suiDialogRightContent]',
  standalone: true,
})
export class SuiDialogRightContentSlot {}

@Directive({
  selector: '[suiDialogRightFooter]',
  standalone: true,
})
export class SuiDialogRightFooterSlot {}
